import AudioContextManager from '../audio/audioContext';
import { generateSpeech } from '../api/elevenlabsApi';
import { useStore } from '../store';

class VoiceService {
  async speak(text: string): Promise<void> {
    const { hasValidApiKeys } = useStore.getState();
    
    if (!hasValidApiKeys()) {
      throw new Error('API keys not configured');
    }

    try {
      const audioBuffer = await generateSpeech(text);
      await AudioContextManager.playAudioBuffer(audioBuffer);
    } catch (error) {
      console.error('Error in voice service:', error);
      throw error;
    }
  }
}

export const voiceService = new VoiceService();